import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const Header = () => {
  const location = useLocation();
  const { t, lang, setLang } = useLanguage();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <nav>
      <Link to="/" className="logo">Havel <em>br</em></Link>
      <ul className="nav-links">
        <li><button onClick={() => scrollToSection('apps')}>{t.nav.apps}</button></li>
        <li><button onClick={() => scrollToSection('sobre')}>{t.nav.about}</button></li>
        <li><button onClick={() => scrollToSection('contato')}>{t.nav.contact}</button></li>
      </ul>
      <div className="nav-right">
        <div className="lang-switch" role="group" aria-label="Idioma / Language">
          <button
            className={lang === 'pt' ? 'active' : ''}
            onClick={() => setLang('pt')}
            aria-pressed={lang === 'pt'}
          >
            PT
          </button>
          <button
            className={lang === 'en' ? 'active' : ''}
            onClick={() => setLang('en')}
            aria-pressed={lang === 'en'}
          >
            EN
          </button>
        </div>
        <button className="nav-btn" onClick={() => scrollToSection('contato')}>{t.nav.cta}</button>
      </div>
    </nav>
  );
};

export default Header;
